// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "@atlaskit-internal_refractor-import" + "." + "f94ace8b" + ".chunk.js";
};